import { useContext } from "react";
import { CompanyContext } from "@/components/CompanyList/CompanyContext";

import { GiftBoxIcon } from "../../../../client/assets/icons/common/GiftBoxIcon";
import { BaseAmazonDiscount } from "../../../../components/BaseComponents/BaseAmazonDiscount";
import { BaseAmazonLabel } from "../../../../components/BaseComponents/BaseAmazonLabel";
import { BaseBenefitsList } from "../../../../components/BaseComponents/BaseBenefitsList";
import { BaseCompanyLogo } from "../../../../components/BaseComponents/BaseCompanyLogo";
import { BaseCoupon } from "../../../../components/BaseComponents/BaseCoupon";
import { BaseFeaturedCompanyHeader } from "../../../../components/BaseComponents/BaseFeaturedCompanyHeader";
import BaseGridRatingHorizontal from "../../../../components/BaseComponents/BaseGridRatingHorizontal";
import BaseLinkWrapper from "../../../../components/BaseComponents/BaseLinkWrapper";
import BaseProductDescription from "../../../../components/BaseComponents/BaseProductDescription";
import BaseServiceFlag from "../../../../components/BaseComponents/BaseServiceFlag";
import { BaseVisitLink } from "../../../../components/BaseComponents/BaseVisitLink";
import getStyles from "./styles";

export const AmazonProduct = () => {
	const { companyIndex, isFeaturedCompany } = useContext(CompanyContext);
	const styles = getStyles({ isFeatured: isFeaturedCompany, companyIndex });

	return (
		<BaseLinkWrapper className={styles.layoutWrapper}>
			<BaseFeaturedCompanyHeader {...styles.featuredCompanyHeader} />
			<BaseCoupon {...styles.coupon} icon={<GiftBoxIcon />} />

			<div className={styles.rootGrid}>
				{/* Column 1 */}
				<div className={styles.col1}>
					<BaseServiceFlag classNames={styles.serviceFlag} />
					<div className={styles.logoWrapper}>
						<BaseCompanyLogo classNames={styles.companyLogo} />
					</div>
				</div>

				{/* Column 2 */}
				<div className={styles.col2}>
					<div>
						<BaseProductDescription
							className={styles.productDescription.text}
						/>
					</div>
					<div>
						<BaseGridRatingHorizontal classNames={styles.rating} />
					</div>
					<div>
						<BaseBenefitsList {...styles.benefitsList} />
					</div>
				</div>

				{/* Column 3 */}
				<div className={styles.col3}>
					<div>
						<BaseAmazonDiscount {...styles.discount} />
						<BaseVisitLink {...styles.visitLink}>Check Price</BaseVisitLink>
						<BaseAmazonLabel {...styles.amazonLabel} />
					</div>
				</div>
			</div>
		</BaseLinkWrapper>
	);
};
